module.exports = __webpack_public_path__ + "img/medassure_logo.68a307a5.jpg";